import EventEmitter from 'events'

class RangeInput extends EventEmitter {
  constructor(wrapper) {
    super()
    this.minVal = null
    this.maxVal = null
    this.wrapperEl = wrapper

    this.listenInputEvets()
  }

  listenInputEvets() {
    const onUnfocus = (wrapperEl) => {

    };

    //
    // Min input event listeners
    //
    if (
      document.querySelector(`${this.wrapperEl} input[data-range-input=min]`)
    ) {
      // On input change
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=min]`
      ).onchange = (e) => {
        this.minVal = e.target.value
        this.emit('change', { min: this.minVal, max: this.maxVal })
      }

      // On input focus
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=min]`
      ).onfocus = (e) => {
        document
          .querySelector(`${this.wrapperEl} .suggestions-min`)
          .classList.add('open');

        setTimeout(() => {
          document
            .querySelector(`.filter-overlay`)
            .classList.add('open');
        }, 105)
          
      }

      // On input blur
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=min]`
      ).onblur = (e) => {
        this.emit('blur')

        document
          .querySelector(`.filter-overlay`)
          .classList.remove('open')

        // We need to wait a little for 
        // the click event register before closing the dropdown
        setTimeout(() => {
          document
            .querySelector(`${this.wrapperEl} .suggestions-min`)
            .classList.remove('open')
        }, 300)
      }
    }

    //
    // Max input event listeners
    //
    if (
      document.querySelector(`${this.wrapperEl} input[data-range-input=max]`)
    ) {
      // On input change
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=max]`
      ).onchange = (e) => {
        this.maxVal = e.target.value

        this.emit('change', { min: this.minVal, max: this.maxVal })
      }

      // On input focus
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=max]`
      ).onfocus = (e) => {
        document
          .querySelector(`${this.wrapperEl} .suggestions-max`)
          .classList.add('open');

        setTimeout(() => {
          document
            .querySelector(`.filter-overlay`)
            .classList.add('open');
        }, 105)
      }

      // On input blur
      document.querySelector(
        `${this.wrapperEl} input[data-range-input=max]`
      ).onblur = (e) => {
        this.emit('blur')

        document
          .querySelector(`.filter-overlay`)
          .classList.remove('open')

        setTimeout(() => {
          document
            .querySelector(`${this.wrapperEl} .suggestions-max`)
            .classList.remove('open')
        }, 300)
      }
    }
  }
}

export default RangeInput